export type AccessibilityLevel = "green" | "yellow" | "red" | "gray";

interface AccessibilityConfig {
  label: string;
  bg: string;
  dot: string;
  level: AccessibilityLevel;
  hex: string;
}

export type IconSet = { green: string; yellow: string; red: string; gray: string };

export const ACCESSIBILITY_STATUS_CONFIG: Record<string, AccessibilityConfig> = {
  fully_accessible: {
    label: "Fully Accessible",
    bg: "#E3F5E1",
    dot: "#74CE6A",
    level: "green",
    hex: "#4CAF50",
  },
  partially_accessible: {
    label: "Partially Accessible",
    bg: "#FFF6E4",
    dot: "#FFB300",
    level: "yellow",
    hex: "#FF9800",
  },
  not_accessible: {
    label: "Not Accessible",
    bg: "#FFDDDD",
    dot: "#F45151",
    level: "red",
    hex: "#F44336",
  },
  no_data: {
    label: "No Data",
    bg: "#F0F0F0",
    dot: "#626262",
    level: "gray",
    hex: "#9E9E9E",
  },
};

export const getAccessibilityLabel = (status: string): string => {
  return ACCESSIBILITY_STATUS_CONFIG[status]?.label || status;
};

export const getAccessibilityLevel = (status: string): AccessibilityLevel => {
  return ACCESSIBILITY_STATUS_CONFIG[status]?.level || "gray";
};

export const getAccessibilityColor = (status: string): string => {
  return ACCESSIBILITY_STATUS_CONFIG[status]?.hex || "#9E9E9E";
};
